export const COLETAS_EXPORT_MAX = 5000;
export const COLETAS_EXPORT_PAGE_SIZE = 50;
